import React, { useReducer } from 'react';
import { v4 as uuidv4 } from 'uuid';
import AddressContext from './addressContext';
import AddressReducer from './addressReducer';
import { ADD_ADDRESS, DELETE_ADDRESS } from '../types';

const AddressState = (props) => {
  const initialState = {
    userAddress: [
      {
        id: 1,
        email: '',
        prefixNum: '',
        number: '9811223456',
        firstname: 'John',
        lastname: 'Doe',
        addressAdd: '123, Ground floor, Ghatkopar enclave',
        city: 'Bengaluru',
        country: '',
        state: 'Karnataka',
        pincode: '560068',
      },
      {
        id: 2,
        email: '',
        prefixNum: '',
        number: '9811223456',
        firstname: 'John',
        lastname: 'Doe',
        addressAdd: '123, Ground floor, Ghatkopar enclave',
        city: 'Bengaluru',
        country: '',
        state: 'Karnataka',
        pincode: '560068',
      },
    ],
  };
  const [state, dispatch] = useReducer(AddressReducer, initialState);

  // add address
  const addAddress = (address) => {
    address.id = uuidv4();
    dispatch({ type: ADD_ADDRESS, payload: address });
  };

  // delete address
  const deleteAddress = (id) => {
    dispatch({ type: DELETE_ADDRESS, payload: id });
  };

  return (
    <AddressContext.Provider
      value={{
        userAddress: state.userAddress,
        addAddress,
        deleteAddress,
      }}
    >
      {props.children}
    </AddressContext.Provider>
  );
};

export default AddressState;
